import React from "react";
import { Box, Switch, FormControlLabel } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import LabeledDateTimePicker from "./LabeledDateTimePicker";
import { useTranslation } from "react-i18next";

const ScheduleSection = ({ 
  isScheduled, 
  setIsScheduled, 
  scheduleDateTime, 
  setScheduleDateTime, 
  loading,
  hideToggle = false
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  
  return (
    <>
      {/* 예약 게시 옵션 */}
      {!hideToggle && (
        <Box 
          sx={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "space-between", 
            width: "100%", 
            marginBottom: theme.spacing(2) 
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={isScheduled}
                onChange={(event) => {
                  setIsScheduled(event.target.checked);
                  if (!event.target.checked) {
                    setScheduleDateTime(new Date());
                  }
                }}
                disabled={loading}
              />
            }
            label={t("postThreads.schedule.title")}
          />
        </Box>
      )}

      {/* 예약 시간 선택 */}
      {isScheduled && (
        <LabeledDateTimePicker
          label={t("postThreads.schedule.time")}
          placeholder={t("postThreads.schedule.placeholder")}
          value={scheduleDateTime}
          onChange={setScheduleDateTime}
          disabled={loading}
          minDate={new Date()}
        />
      )}
    </>
  );
};

export default ScheduleSection; 